@if (isAdvancedSearchApplied()) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All results"
  icon="sapphire-search"
    [active]="filterKey === 'search_results'"
    (execute)="selectFilter('search_results')"
  />
}

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Tasks"
  icon="sapphire-tasks"
  [active]="filterKey === 'all_tasks'"
  (execute)="selectFilter('all_tasks')"
  />

  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="Overdue"
  icon="sapphire-overdue"
    [active]="filterKey === 'overdue'"
    (execute)="selectFilter('overdue')"
    />

    <app-context-menu-item
      [withCheckOption]="true"
      [close]="true"
      title="Today"
  icon="sapphire-today"
      [active]="filterKey === 'today'"
      (execute)="selectFilter('today')"
      />

      <app-context-menu-item
        [withCheckOption]="true"
        title="Next 7 days"
  icon="sapphire-week"
  [active]="
    filterKey === 'week' ||
    filterKey === 'day0' ||
    filterKey === 'day1' ||
    filterKey === 'day2' ||
    filterKey === 'day3' ||
    filterKey === 'day4' ||
    filterKey === 'day5' ||
    filterKey === 'day6'
  "
        (execute)="selectFilter('week')"
        >
        @for (day of nextWeekDays; track day.date; let first = $first; let index = $index) {
          <app-context-menu-item
            [withCheckOption]="true"
            [close]="true"
            [title]="first ? 'Tomorrow' : day.date | dateFormat: 'dayOfWeek'"
            [active]="filterKey === day.name"
            (execute)="selectFilter(day.name)"
            />
        }
      </app-context-menu-item>

      <app-context-menu-item
        [withCheckOption]="true"
        title="Priority"
  icon="sapphire-priority"
  [active]="
    filterKey === 'priority' ||
    filterKey === 'low' ||
    filterKey === 'normal' ||
    filterKey === 'high'
  "
        (execute)="selectFilter('priority')"
        >
        @for (priority of prioritiesList; track priority.value) {
          <app-context-menu-item
            [withCheckOption]="true"
            [close]="true"
            [title]="priority.title"
            [active]="filterKey === priority.value"
            (execute)="selectFilter(priority.value)"
            />
        }
      </app-context-menu-item>

      <app-context-menu-item
        [withCheckOption]="true"
        [close]="true"
        title="Flagged"
  icon="sapphire-flagged"
        [active]="filterKey === 'flagged'"
        (execute)="selectFilter('flagged')"
        />

        <app-context-menu-item
          [withCheckOption]="true"
          [close]="true"
          title="Follow Up"
  icon="sapphire-follow-up"
          [active]="filterKey === 'followed'"
          (execute)="selectFilter('followed')"
          />

          <app-context-menu-item
            [withCheckOption]="true"
            [close]="true"
            title="Snoozed"
  icon="sapphire-snooze"
            [active]="filterKey === 'snoozed'"
            (execute)="selectFilter('snoozed')"
            />

          <app-context-menu-item
            [withCheckOption]="true"
            [close]="true"
            title="Archive"
  icon="sapphire-archive"
            [active]="filterKey === 'archived'"
            (execute)="selectFilter('archived')"
            />

            <app-context-menu-item
              [withCheckOption]="true"
              [close]="true"
              title="Trash"
  icon="sapphire-trash"
              [active]="filterKey === 'deleted'"
              (execute)="selectFilter('deleted')"
              />

              <app-context-menu-item
                [withCheckOption]="true"
                [close]="true"
                title="Projects"
  icon="sapphire-project"
                [active]="filterKey === 'all_projects'"
                (execute)="selectFilter('all_projects')"
                />
